var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCelphone = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 30,
    viewBox: "0 0 29 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.61607 6.58591C9.61607 5.9236 10.1546 5.3839 10.8181 5.3839H19.2322C19.8957 5.3839 20.4342 5.9236 20.4342 6.58591V23.4141C20.4342 24.0764 19.8957 24.6161 19.2322 24.6161H10.8181C10.1546 24.6161 9.61607 24.0764 9.61607 23.4141V6.58591ZM10.8181 25.8181H19.2322C20.558 25.8181 21.6362 24.7399 21.6362 23.4141V6.58591C21.6362 5.26009 20.558 4.18188 19.2322 4.18188H10.8181C9.49227 4.18188 8.41406 5.26009 8.41406 6.58591V23.4141C8.41406 24.7399 9.49227 25.8181 10.8181 25.8181ZM13.2221 7.78792H16.8293V6.58591H13.2221V7.78792ZM15.0251 21.0101C14.6946 21.0101 14.4241 21.2793 14.4241 21.6111C14.4241 21.9428 14.6946 22.2121 15.0251 22.2121C15.3557 22.2121 15.6261 21.9428 15.6261 21.6111C15.6261 21.2793 15.3557 21.0101 15.0251 21.0101ZM15.0251 23.4141C14.0311 23.4141 13.2221 22.6051 13.2221 21.6111C13.2221 20.617 14.0311 19.808 15.0251 19.808C16.0192 19.808 16.8281 20.617 16.8281 21.6111C16.8281 22.6051 16.0192 23.4141 15.0251 23.4141Z",
    fill: "#2C2A29"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgCelphone);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Celphone.bfd6d64ab3689879a79cf520889340bd.svg";